import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface LoaderState {
    value: boolean;
}

const initialState: LoaderState = {
    value: false
}

export const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        isLoading: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
})

export const {isLoading} = loaderSlice.actions;

export default loaderSlice.reducer;